import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Wholesale from '@digital-retail/wholesale';
import { withApplicationContext } from '../../utils/ApplicationContext';
import getLabels from './WholesaleBadge.labels';

const WholesaleBadge = ({ appCtx, quantityToBuyValue, quantityToBuyOperator, discountPercent }) => {
  const labels = getLabels(appCtx);
  const type = {
    cl: 'wholesale',
    pe: 'volume',
  }[appCtx.regionCode];

  return (
    <Wholesale.Badge
      quantityToBuyValue={quantityToBuyValue}
      analytics={{}}
      quantityToBuyOperator={quantityToBuyOperator}
      labels={labels}
      discountPercent={discountPercent}
      type={type}
    />
  );
};

WholesaleBadge.propTypes = {
  appCtx: PropTypes.object.isRequired,
  quantityToBuyValue: PropTypes.number.isRequired,
  quantityToBuyOperator: PropTypes.string.isRequired,
  discountPercent: PropTypes.number.isRequired,
};

export { WholesaleBadge };
export default withApplicationContext(WholesaleBadge);
